module.exports = __webpack_public_path__ + "img/undraw_add_document_0hek.7d35d7cd.svg";